module.exports = __webpack_public_path__ + "media/images/application/placeholder/twitter-preview-e4fd3b8fe409d8067f2137e4c0e08be3.png";